import React, { Fragment } from 'react';
import blogSingle from '../../assets/images/blog/blog-single.jpg';
import { Container, Row, Col, Media, CardBody, Card } from 'reactstrap';
import { Blogimgdate, Comment, Comments, Hits, MarkJecno, Modalcontent, singleblogcontent, singleblogpara } from '../../Constant';
import { Breadcrumbs, H4, H6, LI, P, UL, Image } from '../../AbstractElements';
import { BlogSingleData } from '../../Data/Blog';

const BlogSingleContainer = () => {
  const image = require.context('../../assets/images/blog', true);
  const getImage = (images) => {
    return image(`./${images}`);
  };
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Blog Single' parent='Blog' title='Blog Single' />
      <Row>
        <Col sm='12'>
          <div className='blog-single'>
            <div className='blog-box blog-details'>
              <div className='banner-wrraper bg-size' style={{ backgroundImage: `url(${blogSingle})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', display: 'block' }}></div>
              <Card>
                <CardBody>
                  <div className='blog-details'>
                    <UL className='blog-social simple-list'>
                      <LI className='digits'>{Blogimgdate}</LI>
                      <LI>
                        <i className='icofont m-0 icofont-user'></i>
                        {MarkJecno}
                      </LI>
                      <LI className='digits'>
                        <i className='icofont m-0 icofont-thumbs-up'></i>
                        {Hits}
                      </LI>
                      <LI className='digits'>
                        <i className='icofont m-0 icofont-ui-chat'></i>
                        {Comments}
                      </LI>
                    </UL>
                    <H4>{singleblogpara}</H4>
                    <div className='single-blog-content-top'>
                      <P>{Modalcontent}.</P>
                      <P>{singleblogcontent}</P>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
            <Card className='comment-box'>
              <CardBody>
                <H4>{Comment}</H4>
                <UL className='simple-list'>
                  {BlogSingleData.map((item) => (
                    <Fragment key={item.id}>
                      <LI key={item.id}>
                        <Media className='d-md-flex align-self-center'>
                          <Image className='align-self-center' src={getImage(item.img)} />
                          <Media body className='flex-grow-1'>
                            <Row>
                              <Col md='4'>
                                <a href='#javascript'>
                                  <H6 className='mt-0'>
                                    {item.name}
                                    <span> {item.post}</span>
                                  </H6>
                                </a>
                              </Col>
                              <Col md='8'>
                                <UL className='comment-social ms-auto text-end d-block simple-list'>
                                  <LI>
                                    <i className='icofont m-0 icofont-thumbs-up'></i>
                                    {item.hits}
                                  </LI>
                                  <LI>
                                    <i className='icofont m-0 icofont-ui-chat'></i>
                                    {item.comments}
                                  </LI>
                                </UL>
                              </Col>
                            </Row>
                            <P>{item.para}</P>
                          </Media>
                        </Media>
                      </LI>
                      <LI>
                        {item.commentReplay && (
                          <UL className='simple-list'>
                            {item.commentReplay.map((item) => (
                              <LI key={item.id}>
                                <Media className='d-md-flex align-self-center'>
                                  <Image className='align-self-center' src={getImage(item.img)} />
                                  <Media body className='flex-grow-1'>
                                    <Row>
                                      <Col md='4'>
                                        <a href='#javascript'>
                                          <H6 className='mt-0 text-body'>
                                            {item.name}
                                            <span> {item.post}</span>
                                          </H6>
                                        </a>
                                      </Col>
                                    </Row>
                                    <P>{item.para}</P>
                                  </Media>
                                </Media>
                              </LI>
                            ))}
                          </UL>
                        )}
                      </LI>
                    </Fragment>
                  ))}
                </UL>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default BlogSingleContainer;
